import styled from 'styled-components';
import Img from 'gatsby-image';
import { textAlign } from 'styled-system';

import { radius } from '../../theme';

export default styled(Img)`
  border-radius: ${radius};
`;
